<template>
    <div class="search-results">
        <template v-for="(result, index) in results">
            <SearchResultItem
                :key="index"
                :link="result.link"
                :title="result.title && result.title.rendered"
                :excerpt="(!!result.excerpt && result.excerpt.rendered) || (!!result.yoast_head_json && result.yoast_head_json.description)"
            />
        </template>
        <hr v-if="results.length" class="search-results__divider" />
    </div>
</template>

<script>
import SearchResultItem from "./search-results-item";
export default {
    components: {
        SearchResultItem
    },
    props: {
        results: {
            type: Array,
            required: true
        }
    }
};
</script>
